var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeMapChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2994 15.8496H1V28H14.2994V15.8496Z",
    fill: "#3B5175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 1H19.9004V3.70008H29V1Z",
    fill: "#BEBAD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 4.37305H19.9004V10.4482H29V4.37305Z",
    fill: "#3B5175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9967 23.9492H24.7969V27.9993H28.9967V23.9492Z",
    fill: "#BEBAD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1008 23.9492H15.7012V27.9993H24.1008V23.9492Z",
    fill: "#3B5175"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4744 1H1V8.08771H14.4744V1Z",
    fill: "#3B5175"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H1V15H14V9Z",
    fill: "#BEBAD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.201 1H15.7012V10.4503H19.201V1Z",
    fill: "#BEBAD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0006 11.6328H15.7012V23.1081H29.0006V11.6328Z",
    fill: "#BEBAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeMapChart);
export default __webpack_public_path__ + "static/media/tree-map-chart.586d000f6332984e16f000bbe107af2d.svg";
export { ForwardRef as ReactComponent };